<template>
  <v-checkbox
    v-model="isSelected"
    hide-details
    density="compact"
    class="mt-0 pt-0 user-select-checkbox"
  />
</template>

<script>
import { useUserStore } from '@/stores/UserStore.js'

export default {
  name: "UserSelectBox",
  props: {
    user: {
      type: Object,
      required: true,
    }
  },
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {},
  computed: {
    selectedUsers: function() {
      const userStore = useUserStore();
      return userStore.getSelectedUsers;
    },
    isSelected: {
      get() {
        // Using a regular for statement because of reactivity issue
        for(let i = 0; i < this.selectedUsers.length; i++) {
          if (this.user.id === this.selectedUsers[i].id) {
            return true;
          }
        }

        return false;
      },
      set() {
        const userStore = useUserStore();
        userStore.toggleSelection(this.user);
      },

    }
  },
}
</script>

<style lang="scss" scoped>
.user-select-checkbox .v-selection-control--dirty .v-icon {
  color: var(--v-theme-primary) !important;
}

.v-theme--light .user-select-checkbox .v-icon {
  color: rgba(0, 0, 0, 0.7) ;
}

.v-theme--dark .user-select-checkbox .v-icon {
  color: rgba(255, 255, 255, 0.7) ;
}
</style>
